<template>
  <div class="container-fluid">
  <div class="card animated fadeIn">    
    <div class="card-header">
      <strong>Router Summary</strong>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
              <div class="form-group col-sm-3">
                <label for="id">ID</label>
                <input v-model="rowData.id" type="text" name="id" class="form-control" >
              </div>
              <div class="form-group col-sm-4">
                    <label for="name">Name</label>
                    <input v-model="rowData.name" type="text" name="name" class="form-control" readonly>                  
              </div>
              <div class="form-group col-sm-5">
                    <label for="account_id">Account</label>
                    <input v-model="rowData.account_id" type="text" name="account_id" class="form-control" readonly>                  
              </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-6">
                      <label for="model_id">Model</label>                
                      <input v-model="rowData.product_id" type="text" name="model_id" class="form-control" readonly>                    
                </div>
                <div class="form-group col-sm-6">
                    <label for="Account">Account</label>
                    <input v-model="rowData.account_id" type="date" name="account_id" class="form-control" readonly>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-6">
                    <label>Created</label>
                    <input v-model="rowData.created_at" type="text"  class="form-control" readonly>
                </div>
                <div class="form-group col-sm-6">
                    <label>Last Updated</label>
                    <input v-model="rowData.updated_at" type="text"  class="form-control" readonly>
                </div>
            </div>            
            
            <div class="form-group row">
                  <label class="col-md-3 col-form-label" for="text-input">Router Logs</label>
                  <div class="col-md-9">
                    <textarea v-model="rowData.account_logs" name="router_logs" id="router_logs" cols="30" rows="3" class="form-control" readonly></textarea>                  
                  </div>
            </div>
        </div>
      </div>
    </div>    
  </div>
  </div>  
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick (event) {
      console.log('my-detail-row: on-click', event.target)
    }
  },
}
</script>
